import React, { Suspense, Component, lazy } from "react";
import { Provider } from "react-redux";
import { Switch, Route, Router } from "react-router-dom";
import history from "./common/history";
import { PersistGate } from "redux-persist/integration/react";
import styles from "./App.module.scss";
//Instrumentation (below two)
import { getAppInsights } from "./services/monitoring/telemetryService";
import TelemetryProvider from "./services/monitoring/telemtryProvider";
//
import { getEnvironmentVariables } from "./common/utils";
import { Chat } from "./common/conversion/chat";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Routes } from "./common/constants";
import { CompatRouter } from "react-router-dom-v5-compat";
import { LoadingState } from "./components/Spinner";

import ApplicationLanding from "./containers/ApplicationLanding";
import WebsiteLanding from "./containers/WebsiteLanding";
import { Application } from "./common/constants";

const PaymentAuthorisationRedirect = lazy(() =>
  import(
    "./screens/Marketplace/Licensing/Account/Payment/Card/PaymentAuthorisationRedirect"
  )
);

const GitHubOAuthCallback = lazy(() =>
  import("./screens/Marketplace/Dashboard/App/Handlers/Shared/OAuth/GitHub/GitHubOAuthCallback")
);

import { store, persistor } from "./store/store";
import { KeyEventManagerProvider } from "./components/KeyManagement/KeyEventManagerContext";
import { getSubdomain } from "./common/routing";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  appInsights = null;

  Apps = [
    {
      subDomain: "app",
      appName: Application.Application,
      app: ApplicationLanding,
      main: false,
    },
    {
      subDomain: "",
      appName: Application.Website,
      app: WebsiteLanding,
      main: true,
    },
  ];

  getAppLanding = () => {
    const mainApp = this.Apps.find((app) => app.main);

    if (!mainApp) {
      throw new Error("Must have main app");
    }

    let subDomain = getSubdomain(window.location.hostname, getEnvironmentVariables().REACT_APP_HOST);

    if (subDomain === "") {
      return mainApp.app;
    }

    const app = this.Apps.find((app) => app.subDomain === subDomain);

    if (!app) {
      return mainApp.app;
    }

    return app.app;
  };

  render() {
    const AppLandingBasedOnUrl = this.getAppLanding();

    return (
      <div className={styles.App}>
        <React.StrictMode>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <Router history={history}>
                <CompatRouter>
                  <TelemetryProvider
                    connectionString={
                      getEnvironmentVariables().REACT_APP_CONNECTIONSTRING
                    }
                    after={() => {
                      this.appInsights = getAppInsights();
                    }}
                  >
                    <Suspense fallback={<LoadingState message="Loading..." size="sm" />}>
                      {/* <Chat /> */}
                      <Switch>
                        <Route
                          exact
                          path={
                            Routes.Marketplace.Pages.Conversion.Licensing
                              .PaymentAuthorisationRedirect
                          }
                          component={PaymentAuthorisationRedirect}
                        />
                        <Route
                          exact
                          path='/settings/github/oauth/callback'
                          component={GitHubOAuthCallback}
                        />
                        <Route>
                          <KeyEventManagerProvider>
                            <AppLandingBasedOnUrl />
                          </KeyEventManagerProvider>
                        </Route>
                      </Switch>
                    </Suspense>
                  </TelemetryProvider>
                </CompatRouter>
              </Router>
            </PersistGate>
          </Provider>
        </React.StrictMode>
      </div>
    );
  }
}

export default App;
